<template>
  <div id="ai-language" class="editor-modal">
    <h1>{{ $t("ai-translate.title") }}</h1>

    <form @submit.prevent="changeAiTranslationLanguage()">
      <div class="selectors">
        <OutsideClickWrapper @click="languages = []" @focus="languages = []">
          <div class="language-select">
            <custom-input
              v-model="language"
              :placeholder="$t('signupflow.step-3.ai.form.select.placeholder')"
              :label="$t('signupflow.step-3.ai.form.select.label')"
              name="aiTralsationLanguage"
              @input="searchDebounce(language)"
              autoComplete="off"
            />
            <ul class="language-results" v-if="languages">
              <li class="language-result" v-for="(lang, index) in languages" :key="index">
                <button class="" @click.stop.prevent="onLanguageChange(lang)">{{ lang }}</button>
              </li>
            </ul>
          </div>
        </OutsideClickWrapper>
      </div>
      <p class="description text-muted">
        {{ $t("ai-translate.description") }}
      </p>
      <div class="footer">
        <button ref="focus" type="submit" class="btn btn-primary">Done</button>
        <button type="reset" class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </form>
  </div>
</template>
<script>
import OutsideClickWrapper from "@/components/OutsideClickWrapper";
import debounce from "lodash/debounce";
export default {
  components: { OutsideClickWrapper },
  data() {
    return {
      language: "",
      languages: [],
      searchDebounce: debounce((filter) => {
        if (filter.length) this.getLanguages(filter);
        else {
          this.languages = [];
        }
      }, 100)
    };
  },
  methods: {
    changeAiTranslationLanguage() {
      this.$store.commit("setAiTranslationLanguage", {
        language: this.language,
        templateId: this.$store.state.template.metadata.id
      });
      this.$emit("close");
    },
    onLanguageChange(language) {
      this.language = language;
      this.languages = [];
    },
    getLanguages() {
      this.$store.dispatch("getLanguages", this.language).then((res) => {
        this.languages = res;
      });
    }
  },
  mounted() {
    this.language = this.$store.state.aiTranslationLanguage;
  }
};
</script>

<style lang="less">
#ai-language {
  padding: 20px;
  display: flex;
  flex-direction: column;
  form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .language-select {
    position: relative;
    .language-results {
      position: absolute;
      top: calc(100% + 2px);
      left: 0;
      right: 0;
      background: #fff;
      z-index: 999;
      border-radius: 4px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      max-height: 160px;
      overflow-y: auto;
      padding: 0;
      list-style-type: none;
      display: flex;
      flex-direction: column;
      gap: 1px;
      .language-result {
        button {
          padding: 4px 12px;
          width: 100%;
          text-align: left;
          border: none;
          background: none;
          outline: none !important;
        }
        &:hover,
        &focus,
        &:focus-within {
          button {
            background: var(--charcoal-10);
            outline: none;
            border: none;
          }
        }
      }
    }
  }
}
</style>
